var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSellTickets(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 729,
    height: 729,
    viewBox: "0 0 729 729",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10036_14877",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 729,
    height: 729
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 729,
    height: 729,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10036_14877)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.1,
    filter: "url(#filter0_f_10036_14877)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 373.5,
    cy: 561,
    rx: 237.5,
    ry: 102,
    fill: "#0063AF"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter1_f_10036_14877)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 373.5,
    cy: 573.5,
    rx: 160.5,
    ry: 56.5,
    fill: "#0063AF"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M593.654 114.357C662.017 182.803 502.476 472.545 434.05 541.019C365.625 609.492 254.736 609.514 186.373 541.067C118.011 472.621 118.062 361.626 186.488 293.153C254.913 224.68 525.292 45.9107 593.654 114.357Z",
    fill: "#0063AF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M305.435 51.0749C398.837 26.0304 569.811 309.165 594.858 402.709C619.905 496.252 564.493 592.386 471.09 617.431C377.687 642.475 281.665 586.946 256.617 493.403C231.57 399.859 212.032 76.1194 305.435 51.0749Z",
    fill: "#0063AF"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_dd_10036_14877)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 239.082,
    y: 221.007,
    width: 257.502,
    height: 258.646,
    rx: 128.751,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_dd_10036_14877)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 391.461,
    y: 200.739,
    width: 49.1858,
    height: 49.2199,
    rx: 24.5929,
    fill: "#0063AF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_dd_10036_14877)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 229.438,
    y: 438.153,
    width: 31.8261,
    height: 31.8482,
    rx: 15.9131,
    fill: "#0063AF"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M341.163 343.184C328.166 345.283 319.324 357.58 321.414 370.648C323.402 383.08 334.568 391.732 346.84 390.735L353.998 344.672C350.068 343.047 345.661 342.458 341.163 343.184Z",
    fill: "#0063AF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M392.91 352.961C406.072 352.961 416.743 342.232 416.743 328.997C416.743 315.762 406.072 305.033 392.91 305.033C379.747 305.033 369.076 315.762 369.076 328.997C369.076 342.232 379.747 352.961 392.91 352.961Z",
    fill: "#0063AF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M313.346 337.921L308.689 309.933L361.246 301.27L356.589 331.924L313.346 337.921Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.754 290.116L362.453 277.947L362.27 279.093L294.055 290.116L314.478 417.886L365.9 409.575L417.331 417.886L437.754 290.116ZM335.34 386.09C336.906 383.674 339.73 380.645 344.506 379.222L345.383 384.709L344.792 388.405C341.437 388.383 338.219 387.554 335.34 386.09ZM326.843 355.331C329.524 357.474 334.008 360.048 340.138 360.048C340.559 360.048 340.998 360.021 341.434 359.995L342.211 364.86L323.523 367.879C323.304 363.333 324.541 358.986 326.843 355.331ZM355.897 318.958L328.345 323.413L329.1 328.146L355.098 323.942L354.302 328.927L315.736 335.16L311.954 311.498L335.119 307.754L358.285 304.011L355.897 318.958ZM347.8 369.609L347.676 368.831L347.931 368.79L347.8 369.609ZM348.727 363.805L346.918 364.098L346.137 359.214C347.357 358.888 348.541 358.497 349.657 357.982L348.727 363.805ZM350.648 351.785C349.08 352.98 347.333 353.905 345.381 354.485L343.918 345.336C346.499 345.211 349.061 345.568 351.514 346.366L350.648 351.785ZM339.208 346.071L340.672 355.226C335.709 355.379 332.106 353.438 329.822 351.59C332.37 349.029 335.564 347.085 339.208 346.071ZM342.969 369.59L343.753 374.489C337.256 376.228 333.431 380.259 331.355 383.468C328.02 380.712 325.496 376.962 324.29 372.61L342.969 369.59ZM348.246 397.013L355.186 398.134L354.431 402.865L347.49 401.744L348.246 397.013ZM359.138 403.625L359.894 398.894L369.308 400.416L368.552 405.147L359.138 403.625ZM374.013 401.176L385.896 403.095L385.141 407.828L373.257 405.909L374.013 401.176ZM390.604 403.857L400.018 405.379L399.263 410.11L389.848 408.588L390.604 403.857ZM349.004 392.28L364.892 292.903L430.781 303.551L414.895 402.927L349.004 392.28ZM408.002 295.017L408.758 290.284L418.172 291.806L417.417 296.539L408.002 295.017ZM403.295 294.257L393.883 292.736L394.639 288.003L404.051 289.524L403.295 294.257ZM389.178 291.976L379.766 290.454L380.522 285.721L389.934 287.243L389.178 291.976ZM431.536 298.82L422.124 297.299L422.88 292.566L432.292 294.087L431.536 298.82ZM375.815 284.962L375.059 289.695L365.647 288.173L366.403 283.44L375.815 284.962ZM360.675 289.06L356.75 289.695L355.994 284.962L361.474 284.075L360.675 289.06ZM314.392 296.539L313.637 291.806L323.051 290.284L323.807 295.017L314.392 296.539ZM328.514 294.257L327.758 289.524L337.17 288.003L337.926 292.736L328.514 294.257ZM342.631 291.976L341.875 287.243L351.287 285.721L352.043 290.454L342.631 291.976ZM308.929 292.568L309.685 297.301L300.273 298.823L299.517 294.09L308.929 292.568ZM301.031 303.553L359.879 294.042L359.083 299.024L306.494 307.524L311.79 340.651L353.508 333.907L352.281 341.578C348.563 340.485 344.645 340.193 340.784 340.818C326.509 343.124 316.764 356.676 319.059 371.03C321.054 383.516 331.731 392.733 344.034 393.167L343.153 398.688L316.919 402.927L301.031 303.553ZM317.672 407.66L327.084 406.139L327.839 410.869L318.427 412.391L317.672 407.66ZM332.547 410.11L331.791 405.379L342.354 403.673L342.028 405.717L350.88 407.148L332.547 410.11ZM403.967 410.872L404.723 406.141L414.135 407.663L413.379 412.393L403.967 410.872Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.757 355.016C390.165 355.243 391.576 355.356 392.975 355.356C398.445 355.356 403.762 353.638 408.279 350.352C413.954 346.226 417.691 340.124 418.804 333.174C421.097 318.822 411.354 305.27 397.079 302.965C390.168 301.843 383.232 303.504 377.557 307.631C371.882 311.757 368.145 317.859 367.034 324.808C365.924 331.758 367.571 338.732 371.675 344.438C375.777 350.141 381.842 353.899 388.757 355.016ZM377.786 344.251C380.069 342.398 383.678 340.445 388.645 340.606L387.181 349.763C383.606 348.773 380.396 346.875 377.786 344.251ZM391.888 350.525L393.352 341.368C398.119 342.784 400.938 345.773 402.528 348.248C399.232 349.921 395.59 350.714 391.888 350.525ZM406.513 345.641C404.513 342.566 400.676 338.425 394.105 336.649L394.891 331.734L413.58 334.754C412.405 339.041 409.954 342.808 406.513 345.641ZM414.335 330.023L395.647 327.004L396.424 322.139C396.86 322.165 397.299 322.191 397.72 322.191C403.851 322.191 408.334 319.618 411.015 317.475C413.32 321.13 414.557 325.477 414.335 330.023ZM408.038 313.732C405.755 315.582 402.149 317.526 397.187 317.367L398.65 308.21C402.297 309.229 405.49 311.173 408.038 313.732ZM392.87 307.415C393.228 307.415 393.585 307.441 393.943 307.458L392.479 316.61C387.682 315.179 384.853 312.131 383.291 309.711C386.271 308.201 389.536 307.415 392.87 307.415ZM379.314 312.344C381.387 315.556 385.215 319.601 391.726 321.343L390.942 326.244L372.256 323.224C373.429 318.942 375.877 315.177 379.314 312.344ZM371.501 327.955L390.187 330.974L389.41 335.839C382.622 335.446 377.676 338.217 374.811 340.505C372.43 336.733 371.279 332.391 371.501 327.955Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.239 364.312L359.762 355.183L354.466 388.31L410.943 397.438L416.239 364.312ZM406.993 391.943L359.929 384.336L363.711 360.679L410.776 368.285L406.993 391.943Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.602 371.653L372.358 366.921L367.652 366.16L366.896 370.892L371.602 371.653Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.554 376.989L405.311 372.257L377.074 367.694L376.317 372.426L404.554 376.989Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.63 384.927L394.387 380.195L366.15 375.631L365.394 380.363L393.63 384.927Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.054 386.459L403.811 381.727L399.104 380.967L398.348 385.699L403.054 386.459Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.691 329.67L324.397 328.909L323.641 324.177L318.935 324.938L319.691 329.67Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.175 320.201L346.411 315.638L345.655 310.906L317.418 315.469L318.175 320.201Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.123 314.884L355.829 314.123L355.073 309.391L350.366 310.152L351.123 314.884Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_10036_14877",
    x: 36,
    y: 359,
    width: 675,
    height: 404,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 50,
    result: "effect1_foregroundBlur_10036_14877"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_10036_14877",
    x: 173,
    y: 477,
    width: 401,
    height: 193,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20,
    result: "effect1_foregroundBlur_10036_14877"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_dd_10036_14877",
    x: 169.082,
    y: 194.007,
    width: 397.502,
    height: 398.646,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.113725 0 0 0 0 0.0588235 0 0 0 0 0.317647 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10036_14877"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 43
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 35
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.113725 0 0 0 0 0.0588235 0 0 0 0 0.317647 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_10036_14877",
    result: "effect2_dropShadow_10036_14877"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_10036_14877",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_dd_10036_14877",
    x: 321.461,
    y: 173.739,
    width: 189.186,
    height: 189.22,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.113725 0 0 0 0 0.0588235 0 0 0 0 0.317647 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10036_14877"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 43
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 35
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.113725 0 0 0 0 0.0588235 0 0 0 0 0.317647 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_10036_14877",
    result: "effect2_dropShadow_10036_14877"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_10036_14877",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_dd_10036_14877",
    x: 159.438,
    y: 411.153,
    width: 171.826,
    height: 171.848,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.113725 0 0 0 0 0.0588235 0 0 0 0 0.317647 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10036_14877"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 43
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 35
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.113725 0 0 0 0 0.0588235 0 0 0 0 0.317647 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_10036_14877",
    result: "effect2_dropShadow_10036_14877"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_10036_14877",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSellTickets);
export default __webpack_public_path__ + "static/media/sell-tickets.e8a9e4f595a3fbad83fb498a76d1aba4.svg";
export { ForwardRef as ReactComponent };